// §5 事件型別。事件只新增，不修改。
// 稽核軌跡的顯示名稱（§13.6：不在元件裡寫死）
export const EVENT_LABEL = {
    IdBatchGenerated: '號碼產生',
    IdBatchReserved: '號碼預提',
    IdReclaimRequested: '號碼回收申請',
    IdReclaimCompleted: '號碼回收完成',
    IdVoided: '號碼作廢',
    DeliveryReceived: '收料登記',
    PanelRegistered: '面板建檔',
    ReceiptPosted: '入庫／繳庫過帳',
    WorkOrderOpened: '開立工單',
    IssuePosted: '領料過帳',
    WorkOrderClosed: '工單關閉',
    ShipmentPosted: '出廠過帳',
    PanelDetached: '單片抽離',
    PanelScrapped: '單片報廢',
    ItemMerged: '料件合併',
    StockCounted: '盤點',
    AdjustmentPosted: '調整過帳',
    ConfigChanged: '設定變更',
    ScenarioLoaded: '載入情境／重置',
};
//# sourceMappingURL=events.js.map